import { render, staticRenderFns } from "./StockBorraList.vue?vue&type=template&id=d535b6e4&scoped=true"
import script from "./StockBorraList.vue?vue&type=script&lang=js"
export * from "./StockBorraList.vue?vue&type=script&lang=js"
import style0 from "./StockBorraList.vue?vue&type=style&index=0&id=d535b6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d535b6e4",
  null
  
)

export default component.exports